module.exports = __webpack_public_path__ + "img/pin32.dc9484c0.svg";